"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TimeDifferenceConvert = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _dayjs = _interopRequireDefault(require("dayjs"));
var _relativeTime = _interopRequireDefault(require("dayjs/plugin/relativeTime"));
var _RelativeTimePrecise = _interopRequireDefault(require("../../../RelativeTimePrecise"));
_dayjs.default.extend(_relativeTime.default);
_dayjs.default.extend(_RelativeTimePrecise.default);
class TimeDifferenceConvert {
  constructor() {
    (0, _defineProperty2.default)(this, "type", "time-difference");
    (0, _defineProperty2.default)(this, "label", "Relative Time");
    (0, _defineProperty2.default)(this, "description", "Convert seconds to a human-readable relative time, eg. '2 hours'.");
    (0, _defineProperty2.default)(this, "settings", {
      timestamp: {
        type: "toggle",
        title: "Timestamp",
        description: "Treat as a timestamp instead of a number of seconds."
      },
      precise: {
        type: "toggle",
        title: "Precise Time",
        description: "Display time precisely."
      }
    });
  }
  editorLabel(params) {
    let options = [];
    if (params !== null && params !== void 0 && params.precise) {
      options.push("precise");
    }
    if (params !== null && params !== void 0 && params.timestamp) {
      options.push("timestamp");
    }
    return options.join(" ");
  }
  dependencies(context, params, resolver) {
    return {
      precise: params === null || params === void 0 ? void 0 : params.precise,
      timestamp: params === null || params === void 0 ? void 0 : params.timestamp
    };
  }
  create(deps, batcher) {
    return value => {
      let val;
      if (typeof value === "number") {
        val = value;
      } else if (typeof value === "string") {
        val = parseInt(value);
        if (isNaN(val)) {
          val = 0;
        }
      }
      if (val) {
        let time;
        if (deps.timestamp) {
          time = _dayjs.default.unix(val);
        } else {
          time = (0, _dayjs.default)().add(val, "seconds");
        }
        if (deps.precise) {
          return time.fromNowPrecise();
        }
        return time.fromNow(true);
      }
      return null;
    };
  }
}
exports.TimeDifferenceConvert = TimeDifferenceConvert;
//# sourceMappingURL=TimeDifferenceConvert.js.map